//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";

import Utility from "../../../../utility/utility";
import DialogLeaveView from "./dialog_leave_view";
import LanguageManager from "../../../../manager/language_manager";
import ModelData from "../../model_data";

@ccclass
@moduleInit("DialogLeave")
export default class DialogLeave extends ModuleBase<DialogLeaveView, null> {

    scheduleCallback: Function

    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/public_dialog_leave";
        this.viewType = DialogLeaveView;
        this.needViewMask = true
        this.clickAnywhereClose = true
    }

    protected m_intentData: any = null

    onShow(intentData){
        intentData = intentData || {}
        this.m_intentData = intentData
        let content = intentData.content || LanguageManager.t("public_cannotLeave", true)
        let isCheck = intentData.isCheck || ModelData.instance.tableCommonData.autoLeaveWhenGameEnd
        this.view.showPanel(content, isCheck)
    }

    @bindButtonClickEvent('confirmBtn')
    protected on_click_confirm_btn(node: cc.Node){
        ModelData.instance.tableCommonData.autoLeaveWhenGameEnd = this.view.toggle.isChecked
        this.m_intentData.confirmCallback && this.m_intentData.confirmCallback(this.view.toggle.isChecked)
        this.hide()
    }

}